import { LoadingOutlined } from "@ant-design/icons"
import { Input } from "antd"
import TextArea from "antd/lib/input/TextArea"
import ErrorMessage from "components/base/error-message"
import Loading from "components/shared-components/Loading"
import { useFormikContext } from "formik"
import { useEffect, useRef, useState } from "react"

interface TextFieldComponentProps extends React.ComponentProps<typeof TextArea> {
  name: string
  placeholderValue?: string
  autoFocusPopover?: boolean
}

export const TextAreaField = (props: TextFieldComponentProps) => {
  const { 
    name,
    placeholderValue,
    autoFocusPopover,
    ...inputProps
  } = props

  const inputRef = useRef(null)

  const formik = useFormikContext()
  const field = formik.getFieldProps(name)

  const [value, setValue] = useState(field.value)

  // Handle placeholder logic for consistency
  const getUndefineValueForPlaceholder = (val: string) => {
    return placeholderValue && placeholderValue === val ? undefined : val
  }

  useEffect(() => {
    setValue(getUndefineValueForPlaceholder(field.value))
  }, [field.value])

  useEffect(() => {
    if (autoFocusPopover) {
      setTimeout(() => {
        !!inputRef.current && inputRef.current.focus()
      }, 500)
    }
  }, [])

  const errorMsg = !!formik.errors ? formik.errors[name] : ''

  return (
    <>
      <TextArea
        ref={inputRef}
        {...inputProps}
        value={value}
        onChange={(e) => {
          const inputValue = e.target.value
          setValue(getUndefineValueForPlaceholder(inputValue))
          formik.setFieldValue(field.name, getUndefineValueForPlaceholder(inputValue))

          if (inputProps.onChange) inputProps.onChange(e)
        }}
      />
        <ErrorMessage msg={errorMsg} />
    </>
  )
}